import { message } from 'antd'
import Cookies from 'js-cookie'
import { push } from 'react-router-redux'
import { take, put, call, select } from 'redux-saga/effects'
import { handlerCnames } from '@console/utils/index'
import {
  INITIAL_USER_INFO,
  // INITIAL_REGISTER_INFO,
  LOGIN_SUCCESS,
  GET_DEVELOPER_INFO_SUCCESS,
  GET_USER_INFO_SUCCESS,
  LOGINOUT,
  LOGINOUT_SUCCESS,
  // REFRESH_BROWSER,
  // REGISTER_END,
  DOMAINS
  // CHANGE_EXAMINETYPE
  // CHANGE_LOGIN
} from '@console/store/actionTypes/homepage'
import { handleOpenPlatformLogin, verifyAppTokenValid, getLang } from '@console/utils'
import * as adminServices from '@console/request/api/admin'
import * as services from '@console/request/api/login'
import { immutableSelector, setUserInfo } from '@/utils/index'
import { getCookiesDomain } from '@/config/environment'
import { getUniversalLoginInfo } from '@/utils/universalLogin'

// 退出登录
function* loginOut() {
  const token = yield select((state) => immutableSelector(state).user.userInfo.apptoken)
  try {
    localStorage.clear()
    // 登出清空 WebIDE cookie 信息
    const d = new Date()
    d.setTime(d.getTime() - 7 * 24 * 60 * 60 * 1000)
    const expires = `expires=${d.toUTCString()}`
    document.cookie = `dev_apptoken=''; domain=.huami.com; path=/;expires=${expires}`
    localStorage.setItem('curLang', getLang())
    Cookies.set('apptoken', '', {
      expires: -10000000,
      domain: getCookiesDomain()
    })
    Cookies.set('userid', '', {
      expires: -10000000,
      domain: getCookiesDomain()
    })
    Cookies.set('hm-user-login-info', '', {
      expires: -10000000,
      domain: getCookiesDomain()
    })
    yield put({ type: LOGINOUT_SUCCESS })
    yield call(services.loginOut, { login_token: token })
    return handleOpenPlatformLogin()
  } catch (error) {
    console.log(error)
    return handleOpenPlatformLogin()
  }
}

// 查询开发者认证信息
function* getDeveloperInfo() {
  try {
    const authInfo = yield call(adminServices.getAuthInfo)
    yield put({ type: GET_DEVELOPER_INFO_SUCCESS, payload: authInfo || {} })
    return authInfo
  } catch (error) {
    console.log(error)
  }
}

// 初始化登录后的用户信息
function* initialUserInfo() {
  try {
    const userInfo = getUniversalLoginInfo()

    if (!userInfo.appToken) {
      return verifyAppTokenValid()
    }

    const {
      token_info: { login_token },
      regist_info: { country_code, region },
      thirdparty_info: { email: contact, third_id, nickname },
      domains,
      appToken,
      userId
    } = userInfo

    yield put({ type: LOGIN_SUCCESS, payload: true })
    yield put({ type: DOMAINS, payload: domains })
    yield call(handlerCnames, domains)

    // 设置部分用户信息
    yield put({
      type: GET_USER_INFO_SUCCESS,
      payload: {
        userid: userId,
        apptoken: appToken,
        loginToken: login_token,
        country: country_code?.toLocaleLowerCase(),
        region,
        contact,
        nickName: nickname,
      }
    })

    // 获取开发者相关信息
    const authInfo = yield call(getDeveloperInfo)
    localStorage.setItem('examineType', `${authInfo?.examineType || 0}`)

    if (userId) {
      // 获取user profile
      const { data: userProfile } = yield call(services.getUserInfo, userId, appToken)

      // 获取用户注册地信息
      const {
        data: { country_code: countryCode }
      } = yield call(services.userRegistration, userId, appToken)

      if (userProfile?.userId) {
        // 设置部分用户信息
        yield put({
          type: GET_USER_INFO_SUCCESS,
          payload: {
            ...userProfile,
            country: (countryCode || country_code || userProfile?.country)?.toLocaleLowerCase(),
            avatar: userProfile?.iconUrl
          }
        })
      }

      yield call(setUserInfo, {
        userid: userId,
        apptoken: appToken,
        nickName: userProfile?.nickName || nickname,
        login_token,
        contact,
        country: (countryCode || country_code || userProfile?.country)?.toLocaleLowerCase(),
        iconUrl: userProfile?.iconUrl,
        userIntroduction: userProfile?.userIntroduction,
        third_id
      })

      if (!userProfile?.country && !countryCode && !country_code) {
        const registrationEmpty = yield select((state) => immutableSelector(state)?.i18n?.platform?.loginAndReg?.commonTips?.registrationEmpty)
        message.warning(registrationEmpty)
      }
    }
  } catch (error) {
    console.log(error)
  }
}

// 初始化注册后的用户信息
// function* initialRegisterInfo() {
//   try {
//     let regLastRes: any = Cookies.get('hm-user-login-info')
//     if (!regLastRes) return
//     regLastRes = JSON.parse(regLastRes)

//     const {
//       token_info: { app_token, user_id, login_token },
//       regist_info: { country_code },
//       thirdparty_info: { nickname, icon, third_id, email },
//       domains
//     } = regLastRes
//     // 域名
//     yield call(handlerCnames, domains)
//     yield put({ type: DOMAINS, payload: domains })
//     // 用户信息
//     yield put({
//       type: REGISTER_END,
//       payload: {
//         userid: user_id,
//         apptoken: app_token,
//         nickName: nickname,
//         country: country_code.toLocaleLowerCase(),
//         avatar: icon,
//         developerID: third_id,
//         email
//       }
//     })
//     // 存到localstorage
//     yield call(setUserInfo, {
//       userid: user_id,
//       apptoken: app_token,
//       nickName: nickname,
//       login_token,
//       contact: email,
//       iconUrl: '',
//       country: country_code.toLocaleLowerCase(),
//       userIntroduction: ''
//     })
//   } catch (error) {
//     console.log(error)
//   }
// }

// 统一登录的后续操作
export function* initialUserInfoFlow() {
  while (true) {
    yield take(INITIAL_USER_INFO)
    yield call(initialUserInfo)
  }
}

// 统一注册的后续操作
// export function* initialRegisterInfoFlow() {
//   while (true) {
//     yield take(INITIAL_REGISTER_INFO)
//     yield call(initialRegisterInfo)
//   }
// }

// 退出登录
export function* loginOutFlow() {
  while (true) {
    yield take(LOGINOUT)
    yield call(loginOut)
    yield put(push(''))
  }
}
